import { getBusinessOperation } from "../../../../../actions/Utilities/BusinessOperation";
import { useQuery, useQueryClient } from "react-query";

export const useBusinessOperation = () => {
  return useQuery("GetBusinessOperation", getBusinessOperation, {
    refetchOnWindowFocus: false,
  });
};
